// dropnav.js — ONE place the up/down/enter keyboard behaviour lives for imperative
// dropdown result lists (the `.cb-drop-item` / search-result pattern). Every search box
// across the app (cashbook allocate, GL & contact pickers, journals, quick invoice, docs)
// drives its result list through this so they all behave identically (live parity):
//   ArrowDown / ArrowUp → move the highlight (top match pre-highlighted so Enter is instant)
//   Enter               → click the highlighted row (or the only row)
//   Escape              → opts.onEscape()
// `container` holds the clickable rows matching `itemSelector`; a muted "No matches" row
// is skipped. Wire it as a keydown listener on the search input; the container's children
// may be rebuilt on every keystroke — the handler reads them live.

const DEFAULTS = { itemSelector: '.cb-drop-item:not(.cb-drop-muted)', hl: 'highlighted', wrap: true };

// Pre-highlight the top result (call after each re-render so Enter selects it immediately —
// live's allocate popup highlights the top match the moment results appear).
export function highlightFirst(container, opts = {}) {
  const o = { ...DEFAULTS, ...opts };
  if (!container) return;
  const items = container.querySelectorAll(o.itemSelector);
  items.forEach((el, i) => el.classList.toggle(o.hl, i === 0));
}

// Keydown handler for a search input whose results live in `container`. Returns true when
// it handled the key (so the caller can stop there). Pass { wrap:false } to clamp at the
// ends (live's allocate popup clamps); the default wraps (live's quick-add cycles).
export function dropdownKeydown(e, container, opts = {}) {
  const o = { ...DEFAULTS, ...opts };
  if (!container) return false;
  const items = Array.from(container.querySelectorAll(o.itemSelector));
  const current = container.querySelector(o.itemSelector + '.' + o.hl);
  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
    e.preventDefault();
    if (!items.length) return true;
    let idx = items.indexOf(current);
    if (current) current.classList.remove(o.hl);
    if (e.key === 'ArrowDown') idx = o.wrap ? (idx + 1) % items.length : Math.min(items.length - 1, idx + 1);
    else idx = o.wrap ? (idx <= 0 ? items.length - 1 : idx - 1) : Math.max(0, idx - 1);
    if (idx < 0) idx = 0;
    items[idx].classList.add(o.hl);
    items[idx].scrollIntoView({ block: 'nearest' });
    return true;
  }
  if (e.key === 'Enter') {
    const target = current || (items.length === 1 ? items[0] : (o.enterFirst ? items[0] : null));
    if (target) { e.preventDefault(); target.click(); return true; }
    return false;
  }
  if (e.key === 'Escape') { if (o.onEscape) o.onEscape(); return true; }
  return false;
}

// Convenience: attach the handler to an input that navigates a (stable) container.
export function attachDropdownNav(input, container, opts = {}) {
  input.addEventListener('keydown', (e) => dropdownKeydown(e, container, opts));
}
